import { render, staticRenderFns } from "./frmszemelyesadatok.vue?vue&type=template&id=ca8b9be0&"
import script from "./frmszemelyesadatok.vue?vue&type=script&lang=js&"
export * from "./frmszemelyesadatok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports